import { create } from 'zustand';

export type ReferralModalKind =
  | 'connect'
  | 'own_leader'
  | 'already_member'
  | 'confirm_use';

type ReferralModalState = {
  isOpen: boolean;
  kind: ReferralModalKind | null;
  code: string | null;
  open: (kind: ReferralModalKind, code: string) => void;
  close: () => void;
};

export const useReferralModalStore = create<ReferralModalState>((set) => ({
  isOpen: false,
  kind: null,
  code: null,
  open: (kind, code) => set({ isOpen: true, kind, code }),
  close: () => set({ isOpen: false, kind: null, code: null }),
}));
